import apiClient, { getApiBaseUrl, getSessionIdFromToken } from './api';

const sessionService = {
  getSessions: async (params = {}) => {
    const response = await apiClient.get('/settings/sessions/', { params });
    return response.data;
  },

  getSessionStats: async () => {
    const response = await apiClient.get('/settings/sessions/stats/');
    return response.data;
  },

  revokeSession: async (id) => {
    const response = await apiClient.post(`/settings/sessions/${id}/revoke/`);
    return response.data;
  },

  revokeAllSessions: async (payload = {}) => {
    const response = await apiClient.post('/settings/sessions/revoke-all/', payload);
    return response.data;
  },

  sendHeartbeat: async () => {
    try {
      const response = await apiClient.post('/auth/session/heartbeat/');
      return response.data;
    } catch (err) {
      return null;
    }
  },

  sendCloseBeacon: (sessionId = null, token = null) => {
    try {
      const activeToken = token || (typeof window !== 'undefined' ? localStorage.getItem('token') : null);
      const sid = sessionId || (activeToken ? getSessionIdFromToken(activeToken) : null);
      if (!sid && !activeToken) return false;

      const baseUrl = getApiBaseUrl();
      const closeUrl = `${baseUrl.replace(/\/+$/, '')}/auth/session/close/`;
      const payload = JSON.stringify({ session_id: sid, token: activeToken });

      if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        const blob = new Blob([payload], { type: 'application/json' });
        const queued = navigator.sendBeacon(closeUrl, blob);
        if (queued) return true;
      }

      if (typeof fetch === 'function') {
        fetch(closeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(activeToken ? { Authorization: `Bearer ${activeToken}` } : {}),
          },
          body: payload,
          keepalive: true,
        }).catch(() => {});
        return true;
      }
    } catch (_) {
      // ignore
    }
    return false;
  },
};

export default sessionService;
